package nl.volleyplanner.api.planner

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.entities.PersonId


@Serializable
data class SetLockRequest(
    val taskId: String,
    val locked: Boolean
)

@Serializable
data class UpdateAssigneeRequest(
    val taskId: String,
    val assignee: PersonId?
)
